import React, { useEffect, useState } from "react";
import { Pencil, Trash2 } from "lucide-react";
import ShowPass from "../../images/svg/ShowPass.svg";
import HidePass from "../../images/svg/HidePass.svg";
import { useSelector } from "react-redux";
import { APIUtility } from "../../Api";
import NoData from "../../components/Common/NoData";
import Loader from "../../components/Common/Loader";
import ConfrimModal from "../../Modal/ConfrimModal";

function ViewPassword({ user }) {
  const [viewPassword, setViewPassword] = useState(false);

  return (
    <div className="flex items-center justify-between px-3 w-full">
      <input
        type={viewPassword ? "text" : "password"}
        value={user.password}
        readOnly
        className="w-full border-none bg-transparent"
      />
      <img
        src={viewPassword ? ShowPass : HidePass}
        alt="Toggle Visibility Icon"
        className="cursor-pointer w-5 h-5 text-gray-400"
        onClick={() => setViewPassword(!viewPassword)}
      />
    </div>
  );
}

const UserTable = ({
  fetchUsers,
  isLoading,
  setShowAdduserModal,
  isEditUser,
  setIsEditUser,
  setEditData,
  setIsLoading,
  searchQuery,
  permissions // Receive searchQuery as a prop
}) => {
  const [visiblePasswords, setVisiblePasswords] = useState({});
  const userData = useSelector((state) => state.data?.userData);
  const [confrimModalShow, setConfrimModalShow] = useState(false);
  const [userId, setUserId] = useState(null);
  const togglePasswordVisibility = (userID) => {
    setVisiblePasswords((prevState) => ({
      ...prevState,
      [userID]: !prevState[userID],
    }));
  };

  const columns = [
    { id: "userID", label: "User ID" },
    { id: "username", label: "User Email" },
    { id: "password", label: "Password" },
    { id: "userRole", label: "User Role" },
    { id: "action", label: "Action" },
  ];

  const DeleteUserdata = async () => {
    const res = await APIUtility.DeleteUser({ id: userId });
    if (res.status == 204) {
      setConfrimModalShow(false);
      fetchUsers();
      setUserId(null);
    }
  };

  useEffect(() => {
    if (userData) {
      setIsLoading(false);
    }
  }, [userData]);

  const filteredUsers = Array.isArray(userData) ? userData?.filter((user) =>
    user.username.toLowerCase().includes(searchQuery.toLowerCase().trim())
  ) : []

  return (
    <div className="h-usertable_h overflow-y-scroll hideScrollBar rounded-md">
      <table className="table-auto relative w-full border-collapse">
        <thead className="sticky top-[0px]">
          <tr className="bg-gray-50">
            {columns.map((column, index) => {
              // Skip rendering the action column if no permissions
              if ((!permissions?.user_edit_button && !permissions?.user_delete_button) && column.id === "action") {
                return null;
              }

              // Calculate if this is the last visible column
              const isLastVisibleColumn =
                index === columns.length - 1 ||
                (index === columns.length - 2 && columns[columns.length - 1].id === "action" &&
                  !permissions?.user_edit_button && !permissions?.user_delete_button);

              return (
                <th
                  key={index}
                  className="text-left text-gray-500 font-medium w-[20%]"
                >
                  <div
                    className={`h-full w-full bg-white px-4 py-2 border-b border-gray-200 ${!isLastVisibleColumn ? "border-r border-gray-200" : ""
                      }`}
                  >
                    {column.id === "action" ? (
                      <div className="flex justify-center">{column.label}</div>
                    ) : (
                      column.label
                    )}
                  </div>
                </th>
              );
            })}
          </tr>
        </thead>
        <tbody>
          {isLoading ? (
            <tr>
              <td className="h-[400px] w-full" colSpan={5}>
                <div className="w-full h-full flex items-center justify-center">
                  <Loader />
                </div>
              </td>
            </tr>
          ) : !filteredUsers || filteredUsers.length === 0 ? (
            <tr>
              <td className="h-[400px] w-full" colSpan={5}>
                <NoData text={"No User Added"} />
              </td>
            </tr>
          ) : (
            filteredUsers.map((user, index) => (
              <tr key={index} className="bg-white border-b border-gray-200">
                <td className="px-4 py-2 text-black font-semibold border-r border-gray-200">
                  {user.id}
                </td>
                <td className="px-4 py-2 text-black font-semibold border-r border-gray-200">
                  {user.username}
                </td>
                <td className="px-2 flex items-center justify-between text-black font-semibold border-r border-gray-200 h-[53px] ">
                  <ViewPassword user={user} />
                </td>
                <td className="px-4 py-2 text-black font-semibold border-r border-gray-200">
                  {user.display_role_name || "N/A"}
                </td>
                {
                  (permissions?.user_edit_button || permissions?.user_delete_button) && <td className="px-4 py-2 flex items-center gap-2 justify-center">
                    {
                      permissions?.user_edit_button && <button
                        className="bg-editIcon p-2 rounded flex items-center"
                        onClick={() => {
                          setEditData(user);
                          setIsEditUser(true);
                          setShowAdduserModal(true);
                        }}
                      >
                        <Pencil className="text-black " size={17} />
                      </button>
                    }
                    {
                      permissions?.user_delete_button && <button
                        className="bg-red-100 p-2 rounded flex items-center"
                        onClick={() => {
                          setUserId(user.id);
                          setConfrimModalShow(true);
                        }}
                      >
                        <Trash2 className="text-red-500" size={17} />
                      </button>
                    }

                  </td>
                }

              </tr>
            ))
          )}
        </tbody>
      </table>
      <ConfrimModal
        show={confrimModalShow}
        onHide={() => setConfrimModalShow(false)}
        onYesClick={DeleteUserdata}
      />
    </div>
  );
};

export default UserTable;
